import { normalizeConfig } from '../utils/normalizeConfig.js';

export function getEffectiveConfig (fallbackScreens = null) {
  const fallback = fallbackScreens || [];
  const stored = localStorage.getItem('dashboardConfig');
  if (!stored) return { screens: normalizeConfig(fallback) };
  try {
    const parsed = JSON.parse(stored);
    if (parsed.headerConfig !== undefined) {
      localStorage.removeItem('dashboardConfig');
      return { screens: normalizeConfig(fallback) };
    }
    return { screens: normalizeConfig(parsed.screens ?? fallback) };
  } catch (e) {
    localStorage.removeItem('dashboardConfig');
    return { screens: normalizeConfig(fallback) };
  }
}
